document.addEventListener('click', function (event) {
  const menu = event.target.closest('.mobile-menu');
  document.querySelectorAll('.mobile-menu[open]').forEach(function (item) {
    if (item !== menu) item.removeAttribute('open');
  });
});

function filterKoolaMomCatalog() {
  const catalog = document.querySelector('.catalog-section');
  if (!catalog) return;

  const filter = window.location.hash.replace('#', '');
  const filters = {
    'mom-care': ['mom-care', 'pumping-storage'],
    feeding: ['feeding-cleaning', 'feeding'],
    'on-the-go': ['on-the-go']
  };

  const activeCategories = filters[filter];
  catalog.querySelectorAll('[data-category]').forEach(function (card) {
    card.hidden = Boolean(activeCategories) && !activeCategories.includes(card.dataset.category);
  });

  if (activeCategories) {
    catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

document.addEventListener('DOMContentLoaded', filterKoolaMomCatalog);
window.addEventListener('hashchange', filterKoolaMomCatalog);
